import { Component, Input }   from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NgForm }             from '@angular/forms';

import { CodeTypeModel }     from '../../app-lite/core/models/code-type';
import { MessagesService }   from '../../app-lite/messages/messages.service';
import { QuickbooksService } from '../../app-lite/quickbooks/quickbooks.service';

@Component({
  selector   : 'wor-quickbooks-country',
  template: require('./quickbooks.country.component.html')
})
export class QuickbooksCountryComponent {
  @BlockUI('quickbooksCountryBlock') block: NgBlockUI;

  @Input() countries: Array<CodeTypeModel>;

  country: string;

  constructor (
    private messagesService  : MessagesService,
    private quickbooksService: QuickbooksService
  ) {}

  submit ( form : NgForm ) : void {
    this.block.start();

    this.quickbooksService.getSignupUrlFromCountry(this.country)
    .then(( url : string ) => window.location.assign(url))
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }
}
